import React, { useEffect, useState } from "react";

import {
  Backdrop,
  Box,
  Button,
  ButtonBase,
  Card,
  Fade,
  Modal,
  Typography,
} from "@mui/material";
import parse from "html-react-parser";
import { connect } from "react-redux";

import { QuillInput } from "../../common";
import { updateHtmlWithBodyContent } from "../../utils/functions";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { lg: "35vw", md: "50vw", sm: "80vw", xs: "95vw" },
  height: "auto",
  maxHeight: "96vh",
  bgcolor: "#FBFBFB",
  overflows: "auto",
  boxShadow: 24,
  outline: "none",
  borderRadius: "5px",
};

const PostContentEditModal = ({
  open,
  template,
  user,
  company,
  postContent,
  onEditContent,
  onClose,
}) => {
  const [content, setContent] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const profileName =
    user?.socials?.linkedIn?.page?.page_name ||
    user?.personal_information?.first_name;
  const profileImg =
    user?.socials?.linkedIn?.page?.personal_information?.avatar;

  useEffect(() => {
    if (open && postContent) {
      setContent(postContent);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
        setShowPreview(false);
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            display="flex"
            justifyContent="space-between"
            pl={3}
            alignItems="center"
            bgcolor="white"
            borderRadius="5px"
            borderBottom="1px solid #E8EAED"
          >
            <Typography fontSize="20px" fontWeight={500}>
              Post Preview
            </Typography>
            <Box
              component="img"
              src="https://firebasestorage.googleapis.com/v0/b/getgeek-7c6f1.appspot.com/o/webapp_assets%2Fbubbles.png?alt=media&token=f517d798-dded-486e-97d2-e537bc5ea925"
              height="80px"
            />
          </Box>
          <Box maxWidth={{ xs: "100%", md: "80%" }} mx="auto">
            {showPreview && (
              <Box display="flex" justifyContent="flex-end" px={3} mt={2}>
                <ButtonBase
                  sx={{ borderRadius: "30px" }}
                  onClick={() => setShowPreview(false)}
                >
                  {/* <EditPostContentBtnImg /> */}
                </ButtonBase>
              </Box>
            )}
            <Box
              sx={{
                background: "#4BC7E1",
                p: "1px",
                borderRadius: "17px",
                m: 2,
                zIndex: 1,
              }}
            >
              <Card
                sx={{
                  p: 2,
                  bgcolor: "#FBFBFB",
                  px: { xs: 2, lg: 5 },
                  maxHeight: "60vh",
                  boxShadow: "none",
                  overflow: "auto",
                  borderRadius: "17px",
                  scrollbarWidth: "none",
                }}
              >
                <Box display="flex" gap={2} mb={1} alignItems="center">
                  {showPreview ? (
                    <Typography
                      fontWeight={500}
                      sx={{
                        textDecoration: "underline",
                      }}
                    >
                      Post Content
                    </Typography>
                  ) : (
                    <Typography fontWeight={500}>Edit Content</Typography>
                  )}
                </Box>
                {showPreview ? (
                  <Box className="post_content_container" mb={1}>
                    {parse(content)}
                  </Box>
                ) : (
                  <QuillInput value={content} onChange={setContent} />
                )}

                {template &&
                  (typeof template.renderTemplate === "function" ? (
                    // Case 1: Template has renderTemplate method
                    template.renderTemplate({
                      logo: company?.company_informations?.logo,
                      ...company?.color_theme,
                      width: "100%",
                      height: "100%",
                    })
                  ) : (
                    <img
                      src={template.url || template} // Support both `{ url: ... }` and raw string
                      alt="Template Preview"
                      style={{
                        width: "100%",
                        height: "15rem",
                        objectFit: "contain",
                      }}
                    />
                  ))}
              </Card>
            </Box>
            <Box display="flex" justifyContent="center" gap={2} my={3} px={3}>
              <Button
                variant="outlined"
                sx={{
                  textTransform: "none",
                  borderColor: "#9999",
                  color: "black",
                  borderRadius: "30px",
                }}
                onClick={onClose}
              >
                Cancel Editing
              </Button>
              <Button
                variant="main"
                onClick={() => {
                  if (!showPreview) setShowPreview(true);
                  else {
                    console.log("Before update:", postContent);
                    const hasBodyTag = /<body[^>]*>/i.test(postContent);
                    console.log("Does postContent have <body>? ", hasBodyTag);

                    onEditContent(
                      updateHtmlWithBodyContent(postContent, content)
                    );
                    onClose();
                    setShowPreview(false);
                  }
                }}
              >
                Save & Continue
              </Button>
            </Box>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth?.user,
});

export default connect(mapStateToProps)(PostContentEditModal);
